import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Box,
  Button,
  Typography,
} from "@mui/material";
import image from "../../image/hashtag-polaroid.jpg";

export function ConfirmPaymentPopup({ open, onClose, confirm }) {
  return (
    <Dialog open={open} fullWidth maxWidth="xs">
      <DialogTitle
        sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}
      >
        confirmation paiement
      </DialogTitle>

      <DialogContent>
        <Typography>Confirmez-vous le paiement ?</Typography>
      </DialogContent>
      <DialogActions>
        <Box sx={{ display: "flex", flexDirection: "row" }}>
          <Button variant="contained" color="error" onClick={onClose}>
            Annulé
          </Button>
          <Button
            variant="contained"
            onClick={confirm}
            sx={{ marginLeft: "2%" }}
          >
            Confirmez
          </Button>
        </Box>
      </DialogActions>
    </Dialog>
  );
}
